import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import StatusBadge, { STATUS_LIST } from './components/StatusBadge'
import { listMyReports } from './api/issuesApi'

function fmt(ts) {
  if (!ts) return ''
  return new Date(ts).toLocaleString('th-TH', { dateStyle: 'short', timeStyle: 'short' })
}

export default function IssueMyList({ mode = 'staff' }) {
  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [status, setStatus] = useState('')
  const [q, setQ] = useState('')
  const [loading, setLoading] = useState(true)
  const pageSize = 20
  const base = '/issues'

  const load = async () => {
    setLoading(true)
    try {
      const data = await listMyReports(mode, { page, pageSize, status, q })
      setRows(data.rows || [])
      setTotal(data.total || 0)
    } catch (err) {
      console.error(err)
      setRows([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() /* eslint-disable-next-line */ }, [page, status, mode])

  const onSearch = (e) => { e.preventDefault(); setPage(1); load() }

  const totalPages = Math.max(1, Math.ceil(total / pageSize))

  return (
    <div className={mode === 'staff' ? 'main main-app p-3 p-lg-4' : ''} style={mode === 'staff' ? { maxWidth: 900 } : {}}>
      <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
        <div className="d-flex align-items-center gap-2">
          <i className="ri-file-list-3-line fs-3 text-primary" />
          <h4 className="mb-0">รายการที่ฉันแจ้ง</h4>
        </div>
        <Link to={`${base}/submit`} className="btn btn-primary">
          <i className="ri-add-line me-1" />แจ้งใหม่
        </Link>
      </div>

      <div className="card mb-3">
        <div className="card-body py-2">
          <form className="row g-2" onSubmit={onSearch}>
            <div className="col-12 col-md">
              <input
                type="search"
                className="form-control"
                placeholder="ค้นหาด้วยรหัส/หัวข้อ..."
                value={q}
                onChange={e => setQ(e.target.value)}
              />
            </div>
            <div className="col-7 col-md-3">
              <select className="form-select" value={status} onChange={e => { setStatus(e.target.value); setPage(1) }}>
                <option value="">ทุกสถานะ</option>
                {STATUS_LIST.map(s => (
                  <option key={s.value} value={s.value}>{s.label}</option>
                ))}
              </select>
            </div>
            <div className="col-5 col-md-auto">
              <button className="btn btn-outline-primary w-100" type="submit">
                <i className="ri-search-line me-1" />ค้นหา
              </button>
            </div>
          </form>
        </div>
      </div>

      {loading
        ? <div className="text-center py-5"><span className="spinner-border" /></div>
        : rows.length === 0
          ? <div className="text-center py-5 text-muted">ยังไม่มีรายงานที่ตรงกับเงื่อนไข</div>
          : (
            <div className="d-flex flex-column gap-2">
              {rows.map(r => (
                <Link
                  key={r.ir_id}
                  to={`${base}/detail/${r.ir_id}`}
                  className="card text-decoration-none text-body card-hover"
                >
                  <div className="card-body py-3">
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <i className={`${r.cat_icon} text-primary`} />
                      <span className="small text-muted">{r.ir_code}</span>
                      <StatusBadge status={r.ir_status} className="ms-auto" />
                    </div>
                    <div className="fw-semibold mb-1">{r.ir_title}</div>
                    <div className="small text-muted d-flex flex-wrap gap-2 align-items-center">
                      <span><i className="ri-folder-line me-1" />{r.cat_name}</span>
                      <span><i className="ri-building-line me-1" />{r.dept_name}</span>
                      {r.ir_location && (<span><i className="ri-map-pin-line me-1" />{r.ir_location}</span>)}
                      {r.attachment_count > 0 && (<span><i className="ri-image-line me-1" />{r.attachment_count}</span>)}
                      <span className="ms-auto">{fmt(r.ir_created_at)}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )
      }

      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-3 gap-2">
          <button className="btn btn-outline-secondary btn-sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>
            <i className="ri-arrow-left-s-line" />
          </button>
          <span className="align-self-center small">หน้า {page} / {totalPages}</span>
          <button className="btn btn-outline-secondary btn-sm" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>
            <i className="ri-arrow-right-s-line" />
          </button>
        </div>
      )}
    </div>
  )
}
